// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2bHVj","newExpiryDate":"styles_newExpiryDate__1agbe","footer":"styles_footer__TAj7m"};